import { DARK_MODE_EXCLUDED_PATH_PATTERNS, DARK_MODE_EXCLUDED_PATH_PREFIXES } from '#config/darkMode';

/**
 * Pages matching DARK_MODE_EXCLUDED_PATH_PREFIXES or DARK_MODE_EXCLUDED_PATH_PATTERNS
 * always render in light mode regardless of the user's dark-mode preference. This is the
 * single source of truth for that exclusion, consumed both server-side (to skip injecting
 * the dark-mode bootstrap script) and client-side (to reconcile the `.dark` class on SPA
 * navigation).
 */
export function isDarkModeExcludedPath(pathname: string): boolean {
	return (
		DARK_MODE_EXCLUDED_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)) ||
		DARK_MODE_EXCLUDED_PATH_PATTERNS.some((pattern) => pattern.test(pathname))
	);
}
